'use client';

import { useEffect } from 'react';

type GTagEvent = {
  event: string;
  [key: string]: any;
};

declare global {
  interface Window {
    dataLayer: GTagEvent[];
    gtag: (command: 'config' | 'event' | 'set' | 'js', ...args: any[]) => void;
  }
}

export default function GoogleAnalytics() {
  useEffect(() => {
    // Only run on client side
    if (typeof window !== 'undefined') {
      // Load Google Analytics script
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=YOUR_GA_MEASUREMENT_ID';
      document.head.appendChild(script1);

      // Initialize dataLayer and gtag function
      window.dataLayer = window.dataLayer || [];
      
      // Type the gtag function properly
      window.gtag = function() {
        window.dataLayer.push(arguments as unknown as GTagEvent);
      };
      
      // Initialize with correct types
      window.gtag('js', new Date());
      window.gtag('config', 'YOUR_GA_MEASUREMENT_ID');

      // Cleanup function
      return () => {
        // Remove the script if it exists
        if (script1.parentNode) {
          document.head.removeChild(script1);
        }
      };
    }
  }, []);

  // Return null to avoid hydration mismatch
  return null;
}